export default __webpack_public_path__ + "static/media/NotoSansJP-Regular.24e464fc.ttf";